module.exports = __webpack_public_path__ + "static/media/ImageSelectTickIcon.c79e1882.svg";